import styled from "styled-components";

export const Buttons = styled.div`
  margin-top: 5%;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const SelectionMessage = styled.p`
  width: 100%;
  margin: 10px 0 0;

  color: ${({ theme }) => theme.green};
  font-size: 0.95rem;
  font-weight: bold;
`;
